export const Action = {
  SEND_TICKET: 'SEND_TICKET',
};